const tmpAxis = new THREE.Vector3(0, 0, 1);
const tmpQuat = new THREE.Quaternion();

function createSpinAnim({ framerate, delay, duration, object, axis }) {
    delay = 0;
    // delay = Q3.editMode ? 0 : delay;

    const delayOffset = Math.max(0, delay);
    const stepCount = framerate * duration;
    const timeStepSize = duration / (stepCount - 1);
    const valueStepSize = (2 * Math.PI) / (stepCount - 1);
    const times = [], values = [];

    tmpAxis.copy(axis).applyQuaternion(new THREE.Quaternion().setFromUnitVectors(new THREE.Vector3(0, 1, 0), object.up));

    const animData = Q3.SlideManager.currentSlide.animation[object.uuid];
    const { x: rx, y: ry, z: rz, order: rorder } = animData
        ? Q3.SlideManager.currentSlide.animation[object.uuid].rotation
        : object.rotation;
    const euler = new THREE.Euler(rx, ry, rz, rorder);
    const quaternion = new THREE.Quaternion().setFromEuler(euler);

    if (delay > 0) {
        const stepCount = framerate * delay;
        const timeStepSize = delay / (stepCount - 1);

        for (let i = 0; i < stepCount; i++) {
            const x = i * timeStepSize;

            times.push(x);
            values.push(...object.quaternion.toArray());
        }
    }

    for (let i = 0; i < stepCount; i++) {
        const x = i * timeStepSize;
        const y = valueStepSize * i;

        times.push(x + delayOffset);
        values.push(
            ...(axis.x === 0 && axis.y === 0 && axis.z === 0
                ? tmpQuat.copy(object.quaternion)
                : tmpQuat
                    .setFromAxisAngle(tmpAxis, y)
                    .premultiply(quaternion)
            ).toArray()
        );
    }

    const kfRotation = new THREE.QuaternionKeyframeTrack(".quaternion", times, values);
    const tracks = [kfRotation];
    const clip = new THREE.AnimationClip(THREE.Math.generateUUID(), undefined, tracks);

    return clip;
}

export default createSpinAnim;
export { createSpinAnim };